import { render, staticRenderFns } from "./ProfileDropDownInmo.vue?vue&type=template&id=cf5f2064&scoped=true&"
import script from "./ProfileDropDownInmo.vue?vue&type=script&lang=js&"
export * from "./ProfileDropDownInmo.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDropDownInmo.vue?vue&type=style&index=0&id=cf5f2064&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5f2064",
  null
  
)

export default component.exports